// @flow

import styled, { css } from 'styled-components';
import { media } from '../../../../helpers';
import type { Theme } from '../../../../types';

export const AddressContainer = styled<any, Theme>('div')`
  display: flex;
  margin-bottom: 1rem;
  width: 100%;

  ${media.sm(css`
    width: 66.6666666667%;
  `)}
`;

export const AddressItem = styled<any, Theme>('div')`
  &:nth-child(2) {
    margin: 0 1rem;
  }
`;

export const LabeledField = styled<any, Theme>('div')`
  display: flex;
  flex-direction: column;

  ${media.sm(css`
    flex-direction: row;
  `)}
`;

export const Label = styled<any, Theme>('label')`
  margin: 0.5rem 0;
  width: 100%;

  ${media.sm(css`
    width: 50%;
  `)}
`;
